import React from "react";
import { v4 as uuidv4 } from "uuid";

import Landing from "./Landing";
import History from "../../utilities/History";


import actionHeaderActions from "../../flux/actions/ActionHeaderActions";
import gradeActions from "../../flux/actions/GradeActions";
import gradeListStore from "../../flux/stores/grade/ListStore";

import { IGradeViewData, defaultGradeData } from "../../models/grade/GradeViewData";
import { ISidebarDetail, SidebarDetail } from "../../models/shared/SidebarDetail";
import * as CONSTANTS from "../../utilities/Constants";

import './grade.sass';

import gradeDeleteStore from "../../flux/stores/grade/DeleteStore";
import IActionHeaderFormData, { IActionHeaderEditData } from "../../models/shared/ActionHeaderData";
import gradeByIdStore from "../../flux/stores/grade/ByIdStore";
import { Translation } from "react-i18next";
import triggerNotifications from "../../utilities/TriggerNotifications";

import { GradeFormData, defaultGradeFormData } from "../../models/grade/GradeFormData";
import { defaultTestplanBasicData } from "../../models/testplan/TestplanBasicData";
import NoDataFound from "../shared/NoDataFound";
import gradeFormStore from "../../flux/stores/grade/FormStore";
import SidebarCreate from "../shared/SidebarCreate";
import MeasuredPropertyData, { IMeasuredPropertyData } from "../../models/shared/IMeasuredPropertyData";
import PropertyViewData, { IPropertyViewData } from "../../models/property/PropertyViewData";
import NoDataOnboarding from '../shared/NoDataOnboarding';
import { CHANGE_EVENT, GRADE_CREATE_URL } from '../../utilities/Constants';
import loadingActions from "../../flux/actions/LoadingActions";
import { Input } from "@abb/abb-common-ux-react";
import testplanActions from "../../flux/actions/TestplanActions";
import instrumentActions from "../../flux/actions/InstrumentActions";
import testplanByIdStore from "../../flux/stores/testplan/ByIdStore";
import instrumentSelectedIdStore from "../../flux/stores/instrument/BySelectedIdStore";
import { PropertySpecification } from "../../models/shared/PropertySpecification";
import Sidebar from "../sharedNew/sidebarCommon/sidebar";
import SidebarList from "../sharedNew/sidebarCommon/sidebarList";
import '../sharedNew/sidebarCommon/sidebar.sass';
import SidebarCollapse from "../sharedNew/sidebar/SidebarCollapse";
import productActions from "../../flux/actions/ProductActions";
import { GradeBasicData } from "../../models/grade/GradeBasicData";
import { ProductFormData } from "../../models/product/ProductFormData";
import gradeDisableStore from "../../flux/stores/grade/DisableStore";
import gradeEnableStore from "../../flux/stores/grade/EnableStore";
import IdGenerator from "../../utilities/GenerateId";
import { Spinner } from "@abb/abb-common-ux-react";

interface IGradeLandingState {
  activeId: string;
  activeItem: IGradeViewData;
  listData: ISidebarDetail[];
  isFullSidebarVisible: boolean;
  isClonedCreated: boolean;
  inputGradeName: string;
  showPopup: boolean;
  inputCode: string;
  isData: boolean;
  nameError: boolean;
  codeError: boolean;
  buttonDisabled: boolean;
  searchValue: string;
  collapseSidebar: boolean;
  isLoading: boolean;
}

export default class Index extends React.Component<{ location: any }, IGradeLandingState> {
  private _mount = false;
  private _reloadFirst = true;
  private _id = "";
  private _isSelectedLink = false;
  private _searchId = "";
  private _listData: ISidebarDetail[] = [];
  private _message: string[];
  private _isValid: boolean = false;
  private _fetchedTestplan: any;
  private _fetchedInstruments: any;
  private _page: number = 1;
  private _hasMore: boolean = true;
  private _listRef: any;
  onSearch: any;
  private gradeList: any = [];

  constructor(props: { location: any }) {
    super(props);
    const searchName = this.props.location &&  this.props.location.state && this.props.location.state.searchName  ? this.props.location.state.searchName : '';
    this._mount = false;
    this._listRef = React.createRef();
    this.state = {
      collapseSidebar: false,
      activeId: "",
      searchValue: searchName || "",
      activeItem: defaultGradeData,
      listData: [],
      isFullSidebarVisible: true,
      isClonedCreated: false,
      inputGradeName: "",
      showPopup: false,
      inputCode: "",
      isData: true,
      nameError: false,
      codeError: false,
      buttonDisabled: true,
      isLoading: false
    };
  }

  componentWillUnmount() {
    this._mount = false;
  }

  onCollapseSidebar = () => {

    this.setState({
      collapseSidebar: !this.state.collapseSidebar
    })
  }
  componentDidMount() {
    History.replace({ state: {} })
    this._mount = true;

    gradeFormStore.on(CONSTANTS.CHANGE_EVENT, state => {
      if (this._mount) {
        this._message = state.message;
      }
    })

    const addRequest = {
      moduleName: CONSTANTS.MODULE_GRADE,
      createData: new GradeFormData(uuidv4(), false, "", "", "", "", defaultTestplanBasicData, [], [], [], [])
    } as IActionHeaderFormData;
    actionHeaderActions.common(addRequest).then();

    if (this.props.location.state && this.props.location.state.isReloadFirst !== undefined) {
      this._reloadFirst = this.props.location.state.isReloadFirst;
      this._id = this.props.location.state.id;
    }

    if (
      this.props.location.state &&
      this.props.location.state.isSelectedLink !== undefined
    ) {
      this._isSelectedLink = this.props.location.state.isSelectedLink;
      this._searchId = this.props.location.state.id;
    }

    testplanByIdStore.on(CHANGE_EVENT, (state) => {
      console.log(state);
      this._fetchedTestplan = state.testplanData
    })

    instrumentSelectedIdStore.on(CHANGE_EVENT, (state) => {
      console.log(state);
      this._fetchedInstruments = state.instrumentDataList
    })


    gradeDeleteStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._reloadFirst = state.reload
        setTimeout(() => {
          History.push(CONSTANTS.GRADE_INDEX_URL);
          this.getAll();
        }, CONSTANTS.NOTIFICATION_TIMEOUT);
      }
    })


    gradeListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._listData = [];
        if (state.gradeDataList.currentPage === state.gradeDataList.totalPages || state.gradeDataList.totalRecords === 0) {
          this._hasMore = false;
        } else {
          this._hasMore = true;
        }
        const data = state.gradeDataList.result as IGradeViewData[];
        this.gradeList = state.gradeDataList.result as IGradeViewData[];
        const items: ISidebarDetail[] = [];
        data.forEach(element => {
          items.push(new SidebarDetail(element.id, element.name));
        });

        this._listData = items;
      }
    });

    gradeByIdStore.on(CONSTANTS.CHANGE_EVENT, (state: any) => {
      if (this._mount) {
        this.setState({
          activeItem: state.gradeData,
          activeId: state.gradeData.id,
        })
      }
    });

    gradeDisableStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
      this._reloadFirst = state.reload;
      setTimeout(() => {
        this.getAll();
      }, CONSTANTS.NOTIFICATION_TIMEOUT);
      }
    });

    gradeEnableStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
       if (this._mount) {
       this._reloadFirst = state.reload;
       setTimeout(() => {
         this.getAll();
       }, CONSTANTS.NOTIFICATION_TIMEOUT);
       }
     });

    this.getAll();
  }

  private getAll() {
    loadingActions.setLoading(true);
    this.setState({isLoading: true})
    if (this.state.isClonedCreated) {
      this._page = 1;
    }
    gradeActions.getAll(false, this._page, CONSTANTS.PAGE_SIZE, CONSTANTS.SORT_CREATEDON, CONSTANTS.SORT_ORDER, "").then(() => {
      this.setState({
        listData: this._listData,
        isClonedCreated: false
      }, () => {
        loadingActions.setLoading(false);
        this.setState({isLoading: false})
        const firstItem = this.state.listData[0];
        if (this._reloadFirst) {
          if (this.state.listData.length > 0) {
            this.triggerGetById(firstItem.id);
          } else {
            const data: IActionHeaderEditData = {
              moduleName: CONSTANTS.MODULE_GRADE,
              editData: {},
              deleteTitle: "",
              deleteId: "",
              isEnableViewAll: true,
              deleteRequestId: uuidv4(),
              deleteMessage: ""
            };
            actionHeaderActions.edit(data).then();
          }
        } else {
          this.triggerGetById(this._id);
        }
        if(this.state.searchValue){
          this.onsearch(this.state.searchValue);
        }
      });
    }).catch(() => {
      loadingActions.setLoading(false)
      this.setState({isLoading: false})
    });
  }

  private triggerGetById(id: string) {
    gradeActions.getById(id).then(() => {
    
      const receivedData = this.state.activeItem;

      
      testplanActions.getById(receivedData.testplan.id).then((response) => {
        const propertiesToBeFetched: any[] = [];
        this._fetchedTestplan.keyedIns.forEach((d: any) => {
          propertiesToBeFetched.push(d.id);
        });
        
        const list: any = [];
        (this._fetchedTestplan.keyedIns || []).forEach((item:any) => {
          list.push(new PropertySpecification(false, false, "", item.id, item.name, 0, "",
            "", 0, 1, "", "", "", "", "", "", "", "", []));
        });
  
        this.state.activeItem.calculatedProperties.forEach(item => {
          list.push(new PropertySpecification(false, true, "", item.property.id, item.property.name, item.property.customId, "",
            "", 0, 1, "", "", "", "", "", "", "", "", item.sourceMappings || []));
        });
  

        const allInstruments: any = [];
        // // Fetch Properties for all testplan instruments
        const instrumentsToFetch: string[] = [];
        this._fetchedTestplan.instruments.forEach((d: any) => {
          instrumentsToFetch.push(d.id);
          allInstruments.push(d);
        });

        instrumentActions.getSelected(instrumentsToFetch).then(() => {
          console.log(this._fetchedInstruments);

          this._fetchedInstruments.result.forEach((instrument: any) => {
            instrument.properties.forEach((item: any) => {
              list.push(new PropertySpecification(true, false, instrument.id, item.id, item.name, item.customId, "",
                "", 0, 1, "", "", "", "", "", "", "", "", [], item.direction));
            });
          });
          const editData = new GradeFormData(uuidv4(), true, receivedData.id, receivedData.name, receivedData.description, receivedData.code,
            receivedData.testplan, receivedData.measuredProperties, receivedData.keyedInProperties, receivedData.calculatedProperties, [], list);
          editData.allInstruments = [...allInstruments];
          const uniqSelectedInstruments = editData.selectedInstruments.filter((object, index) => index === editData.selectedInstruments.findIndex(obj => JSON.stringify(obj) === JSON.stringify(object)));
          editData.selectedInstruments = [...uniqSelectedInstruments];
          const data: IActionHeaderEditData = {
            moduleName: CONSTANTS.MODULE_GRADE,
            editData,
            deleteId: receivedData.id,
            deleteRequestId: uuidv4(),
            deleteTitle: receivedData.name,
            deleteMessage: receivedData.name
          };

          actionHeaderActions.edit(data).then();

        });
      }).catch((error) => {
        triggerNotifications.errors(error.message, error.data).then();
      })
    }).catch((error) => {
      triggerNotifications.errors(error.message, error.data).then();
    });
  }

  public onSelectLink = (id: string) => {
    this.setState({ activeId: id });
    this.triggerGetById(id);
  }

  public setName = (value: string) => {
    const val = value.length > 1 ? value : value.replace(/\s/g, "")
    var rgFile = CONSTANTS.COMMONREGEXP;
    if (val.trim() && !rgFile.test(val)) {
      this.setState({ nameError: false, inputGradeName: val }, this.validate)
    } else {
      this.setState({ nameError: true, inputGradeName: val }, this.validate)
    }

  }

  public setCode = (value: string) => {
    const val = value.length > 1 ? value : value.replace(/\s/g, "")
    var rgFile = CONSTANTS.COMMONREGEXP;
    if (val.trim() === "" || (!rgFile.test(val) && val.trim())) {
      this.setState({ codeError: false, inputCode: val }, this.validate)
    } else {
      this.setState({ codeError: true, inputCode: val }, this.validate)
    }
  }

  public onActivate = () => {
    this.setState({
      showPopup: true
    });
  }

  public onDeactivate = () => {
    this.setState({
      showPopup: false
    });
  }

  public onSave = (e: any, val: boolean) => {
    if (e !== null) {
      if (e.keyCode === 13) {
        this.setState({
          showPopup: false,
        });
        const gradeData = this.state.activeItem;
        let calcProps = gradeData.calculatedProperties;
        gradeData.calculatedProperties.map((data) => {
          const property = gradeData.calculatedProperties.find(x => x.property.id === data.property.id);
          const propertyIndex = gradeData.calculatedProperties.findIndex(x => x.property.id === data.property.id);
          if (property !== undefined) {
            if (data.formulaMappings !== undefined) {
              data.formulaMappings[0].variableMapping.map((variables: any) => {
                const sourceId = variables.variableMapping.source === null ? "" : variables.variableMapping.source.id;
                const position = variables.variableMapping.position === null ? "" : variables.variableMapping.position;
                const valueId = variables.variableMapping.value === null ? "" : variables.variableMapping.value.id;
                const sourceMappingData = {
                  sourceId,
                  position,
                  valueId,
                  propertyAttributeId: variables.attribute.id,
                  propertyId: variables.property.id,
                  variable: variables.variable,
                }
                calcProps[propertyIndex].sourceMappings.push(sourceMappingData);
              });
            }
          }
        })
        if (this._isValid) {
          const tempName = this.state.inputGradeName.replace(/ +(?= )/g, '').trim();
          this.setState({
            inputGradeName: tempName
          }, () => {
            const gradeBody = new GradeFormData(uuidv4(), true, gradeData.id, this.state.inputGradeName, gradeData.description, this.state.inputCode,
              gradeData.testplan, gradeData.measuredProperties, gradeData.keyedInProperties, calcProps, []);
            gradeActions.post(gradeBody).then(() => {

              // Product Cloning
              var productFormData = new ProductFormData(
                uuidv4(),
                false,
                "",
                gradeBody.name,
                gradeBody.description,
                gradeBody.code,
                new GradeBasicData(
                  gradeData.id,
                  gradeBody.name,
                  gradeBody.description,
                  gradeBody.code,
                  true
                ),
                [],
                [],
                []
              );

              productFormData.properties = gradeBody.properties;

              productActions
                .post(productFormData)
                .then((res: any) => {
                  triggerNotifications.success(this._message).then();
                  this.setState({
                    inputGradeName: "",
                    inputCode: "",
                    buttonDisabled: true,
                    isClonedCreated: true,
                  });
                  this._listData = [];
                  this.getAll();
                  this._listRef.current.scrollTop = 0;
                })
                .catch((err) => {
                  console.log(err, "Prodcut Not Cloned");
                });
            }).catch((error) => {
              triggerNotifications.errors(error.message, error.data).then();
              this.setState({
                inputGradeName: "",
                inputCode: "",
                buttonDisabled: true,
                isClonedCreated: false
              })
            })
          })
        }
      }
    } else {
      this.setState({
        showPopup: false
      });
      const gradeData = this.state.activeItem;
      let calcProps = gradeData.calculatedProperties;
      gradeData.calculatedProperties.map((data) => {
        const property = gradeData.calculatedProperties.find(x => x.property.id === data.property.id);
        const propertyIndex = gradeData.calculatedProperties.findIndex(x => x.property.id === data.property.id);
        if (property !== undefined) {
          if (data.formulaMappings !== undefined) {
            data.formulaMappings[0].variableMapping.map((variables: any) => {
              const sourceId = variables.variableMapping.source === null ? "" : variables.variableMapping.source.id;
              const position = variables.variableMapping.position === null ? "" : variables.variableMapping.position;
              const valueId = variables.variableMapping.value === null ? "" : variables.variableMapping.value.id;
              const sourceMappingData = {
                sourceId,
                position,
                valueId,
                propertyAttributeId: variables.attribute.id,
                propertyId: variables.property.id,
                variable: variables.variable,
              }
              calcProps[propertyIndex].sourceMappings.push(sourceMappingData);
            });
          }
        }

      })
      if (this._isValid) {
        const tempName = this.state.inputGradeName.replace(/ +(?= )/g, '').trim();
        this.setState({
          inputGradeName: tempName
        }, () => {
          const gradeBody = new GradeFormData(uuidv4(), true, gradeData.id, this.state.inputGradeName, gradeData.description, this.state.inputCode,
            gradeData.testplan, gradeData.measuredProperties, gradeData.keyedInProperties, calcProps, []);
          gradeActions.post(gradeBody).then(() => {
            // Product Cloning
            var productFormData = new ProductFormData(
              uuidv4(),
              false,
              "",
              gradeBody.name,
              gradeBody.description,
              gradeBody.code,
              new GradeBasicData(
                gradeData.id,
                gradeBody.name,
                gradeBody.description,
                gradeBody.code,
                true
              ),
              [],
              [],
              []
            );

            productFormData.properties = gradeBody.properties;

            productActions
              .post(productFormData)
              .then((res: any) => {
                triggerNotifications.success(this._message).then();
                this.setState({
                  inputGradeName: "",
                  inputCode: "",
                  buttonDisabled: true,
                  isClonedCreated: true,
                });
                this._listData = [];
                this.getAll();
                this._listRef.current.scrollTop = 0;
              })
              .catch((err) => {
                console.log(err, "Prodcut Not Cloned");
              });
          }).catch((error) => {
            triggerNotifications.errors(error.message, error.data).then();
            this.setState({
              inputGradeName: "",
              inputCode: "",
              buttonDisabled: true,
              isClonedCreated: false
            })
          })
        })
      }
    }
  }

  validate(): void {
    if (!this.state.codeError && !this.state.nameError &&
      this.state.inputGradeName.trim() && this.state.inputGradeName !== "") {
      this._isValid = true;
      this.setState({
        buttonDisabled: false
      })
    } else {
      this._isValid = false;
      this.setState({
        buttonDisabled: true
      })
    }
  }

  public onCreateClick = () => {

    const createData = new GradeFormData(uuidv4(), false, "", "", "", "", defaultTestplanBasicData, [], [], [], []);
    History.push(GRADE_CREATE_URL, createData)
  }
  public viewAll() {

    History.push(CONSTANTS.GRADE_VIEW_ALL);
  }

  public onsearch = (value: any) => {
    if (value.length >= CONSTANTS.SEARCH_LENGTH || value.length === 0) {
      loadingActions.setLoading(true);
      gradeActions.getAll(false, 1, CONSTANTS.PAGE_SIZE, CONSTANTS.SORT_CREATEDON, CONSTANTS.SORT_ORDER, value).then(() => {
        loadingActions.setLoading(false);
        this.setState({ listData: this._listData, searchValue: value }
          , () => {
            const firstItem = this.state.listData[0];
            if (this.state.listData.length > 0) {
              if(this._isSelectedLink){
                this.triggerGetById(this._searchId);
              }else{
                this.triggerGetById(firstItem.id);
              }
            }
          })
      })
    } else {
      this.setState({ searchValue: value })
    }
  }

  public fetchMore = () => {
    loadingActions.setLoading(true);
    this._page = this._page + 1;
    gradeActions.getAll(false, this._page, CONSTANTS.PAGE_SIZE, CONSTANTS.SORT_CREATEDON, CONSTANTS.SORT_ORDER, this.state.searchValue).then(() => {
      loadingActions.setLoading(false);
      const data = [...this.state.listData, ...this._listData];
      this.setState({ listData: data });
    }).catch(() => loadingActions.setLoading(false));
  }

  public cloneClick = () => {
    this.setState({
      showPopup: true,
    });
  };

  public render() {
    return (
      <Translation>
        {
          t => <div className="layout-margin">
            {this.state.isLoading ? (<div style={{ display: "flex", alignItems: "center", justifyContent: "center", textAlign: 'center', height: "90vh" }}><Spinner color="grey" sizeClass="medium" /></div>) : 
            (<>{(this.state.listData.length === 0 && this.state.searchValue.length === 0) ?
              <NoDataOnboarding moduleName={CONSTANTS.MODULE_GRADE} onCreateClick={this.onCreateClick} authKey={CONSTANTS.AUTHKEY_GRADE}/> :
              <React.Fragment>
                {
                  !this.state.collapseSidebar ?
                    <div>
                      <Sidebar
                        authKey={CONSTANTS.AUTHKEY_GRADE}
                        onCollapseSidebar={this.onCollapseSidebar}
                        searchValue={this.state.searchValue}
                        onSearch={this.onsearch}
                        onCreateClick={this.onCreateClick}
                        viewAll={this.viewAll}
                        cloneClick={this.cloneClick}


                        setName={(val: string) => this.setName(val)}
                        inputName={this.state.inputGradeName}
                        isShowPopup={this.state.showPopup}
                        module={CONSTANTS.MODULE_GRADE}
                        setCode={(val: string) => this.setCode(val)}
                        inputCode={this.state.inputCode}
                        nameError={this.state.nameError}
                        codeError={this.state.codeError}
                        isButtonDisabled={this.state.buttonDisabled}
                        onActivate={this.onActivate}
                        onSave={this.onSave}
                        onDeactivate={this.onDeactivate}
                        showCloneIcon={true}

                      >
                        <SidebarList
                          onSelectLink={this.onSelectLink}
                          listData={this.state.listData}
                          activeId={this.state.activeId}
                          fetchMore={this.fetchMore}
                          hasMore={this._hasMore}
                          module={CONSTANTS.MODULE_GRADE}
                        >
                        </SidebarList>
                      </Sidebar>
                    </div>
                    :
                    <SidebarCollapse
                    authKey={CONSTANTS.AUTHKEY_GRADE}
                      onCollapseSidebar={this.onCollapseSidebar}
                      onCreateClick={this.onCreateClick}
                      viewAll={this.viewAll}
                      cloneClick={this.cloneClick}

                      setName={(val: string) => this.setName(val)}
                      inputName={this.state.inputGradeName}
                      isShowPopup={this.state.showPopup}
                      module={CONSTANTS.MODULE_GRADE}
                      setCode={(val: string) => this.setCode(val)}
                      inputCode={this.state.inputCode}
                      nameError={this.state.nameError}
                      codeError={this.state.codeError}
                      isButtonDisabled={this.state.buttonDisabled}
                      onActivate={this.onActivate}
                      onSave={this.onSave}
                      onDeactivate={this.onDeactivate}
                      showCloneIcon={true}
                    ></SidebarCollapse>
                }
                <div className={`row content-section ${this.state.collapseSidebar ? "expanded" : ""}`}>
                  <Landing
                  />
                </div>
              </React.Fragment>
              }</>)}
          </div>
        }
      </Translation>
    );

  }
}
